@if (variant === 'DEFAULT') {
  <div (click)="toggleTheme()">
    <pr-icon
      #icon
      [name]="theme == 'light' ? 'fa-moon-o' : 'fa-sun-o'"
      [width]="16"
      [height]="16"
    ></pr-icon>
    Mode {{ theme == 'light' ? 'sombre' : 'clair' }}
  </div>
}
@if (variant === 'SWITCH') {
  <div>
    <pr-button-switch
      [values]="[
        { value: false, label: 'light' },
        { value: true, label: 'dark' },
      ]"
      [defaultValue]="theme === 'light' ? false : true"
      (onValueChange)="changeTheme($event.label)"
    ></pr-button-switch>
    Activer le mode {{ theme == 'light' ? 'sombre' : 'clair' }}
  </div>
}
